import { API_BASE } from '../config.js';
import { getDeviceToken } from '../state/device-store.js';
import { logError } from '../state/log-store.js';
import { handleSessionRevoked } from './session-revoked.js';

const DISCONNECT_PATH = '/devices/me/disconnect';

export class ApiError extends Error {
  constructor(message, status, code) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }
}

export async function apiFetch(
  path,
  { method = 'GET', body, auth = true, headers = {}, silent = false, cache } = {},
) {
  if (!navigator.onLine) {
    throw new ApiError('Device is offline', 0, 'OFFLINE');
  }
  const url = `${API_BASE}${path}`;
  const finalHeaders = { 'Content-Type': 'application/json', ...headers };
  if (auth) {
    const token = getDeviceToken();
    if (token) finalHeaders['Authorization'] = `Bearer ${token}`;
  }
  const res = await fetch(url, {
    method,
    headers: finalHeaders,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    ...(cache !== undefined ? { cache } : {}),
  });
  if (!res.ok) {
    let errBody = null;
    try {
      errBody = await res.json();
    } catch {
      /* not JSON */
    }
    const msg = errBody?.message ?? `HTTP ${res.status}`;
    if (!silent) {
      logError(`API ${method} ${path} failed`, { status: res.status, code: errBody?.code });
    }
    if (res.status === 401 && errBody?.code === 'DEVICE_DISCONNECTED' && path !== DISCONNECT_PATH) {
      void handleSessionRevoked();
    }
    throw new ApiError(msg, res.status, errBody?.code);
  }
  if (res.status === 204) return null;
  return res.json();
}
